import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomValidatorDirective } from "app/directives/custom-validator.directive";



@NgModule({
  declarations: [
    CustomValidatorDirective
  ],
  imports: [
  
  ],
  exports: [
    CustomValidatorDirective
  ]
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/directives/directives.module.ts